export const TOXIC_PLANTS = [
  {
    id: "1",
    name: "Rhododendron & Azalea",
    scientificName: "Rhododendron spp.",
    category: "Shrubs & Trees",
    severity: "Critical",
    toxicityScore: 9.5,
    partsAffected: "All parts, especially leaves and nectar",
    toxin: "Grayanotoxins (Andromedotoxin)",
    symptoms: ["Severe drooling", "Loss of appetite", "Colic & abdominal pain", "Green nasal discharge", "Cardiac arrhythmias", "Weakness & tremors"],
    description: "Rhododendrons and azaleas contain grayanotoxins which disrupt sodium channels in cell membranes. Alpacas find them tempting in winter or early spring when forage is low. Ingestion can be rapidly fatal.",
    treatment: "Immediate vet intervention. Gastric lavage, activated charcoal, IV fluids, and cardiac support.",
    image: "https://images.unsplash.com/photo-1508873696983-2df5c92064c7?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Willow (non-toxic varieties), Mulberry, Apple tree branches",
    season: "Year-round (Evergreen)",
    endpoint: "/api/plants"
  },
  {
    id: "2",
    name: "Oleander",
    scientificName: "Nerium oleander",
    category: "Ornamental Plants",
    severity: "Critical",
    toxicityScore: 10,
    partsAffected: "Entire plant, including dried leaves and water source",
    toxin: "Cardiac glycosides (Oleandrin, Neriine)",
    symptoms: ["Sudden collapse", "Bloody diarrhea", "Severe colic", "Irregular weak pulse", "Pupil dilation", "Death within hours"],
    description: "Extremely toxic ornamental shrub. Even a single leaf can be fatal to an alpaca. The toxins cause severe cardiac arrest and gastrointestinal hemorrhaging.",
    treatment: "Emergency veterinary toxicology protocol. Atropine or anti-arrhythmic drugs under strict vet guidance. Do not induce vomiting without vet.",
    image: "https://images.unsplash.com/photo-1589135235318-45a6d38e9c32?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Rose bushes (thornless), Hibiscus (select species)",
    season: "Year-round",
    endpoint: "/api/plants"
  },
  {
    id: "3",
    name: "Red Maple & Maples (Acer)",
    scientificName: "Acer rubrum",
    category: "Trees & Leaves",
    severity: "High",
    toxicityScore: 8.5,
    partsAffected: "Wilted or dried leaves",
    toxin: "Gallotanins and oxidant compounds",
    symptoms: ["Acute hemolytic anemia", "Dark red/brown urine (hemoglobinuria)", "Yellow mucous membranes (jaundice)", "Depression & respiratory distress"],
    description: "Official Alpaca Guild listing includes Acer species. Wilted or dried leaves (fallen in autumn or storm-broken branches) cause severe oxidation of red blood cells in camelids.",
    treatment: "Supportive care, blood transfusions in severe anemia, antioxidant therapy, IV fluids.",
    image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Sugar Maple, Birch, Poplar",
    season: "Autumn / Storm seasons",
    endpoint: "/api/plants"
  },
  {
    id: "4",
    name: "Yew",
    scientificName: "Taxus spp.",
    category: "Evergreens",
    severity: "Critical",
    toxicityScore: 9.8,
    partsAffected: "Needles and seeds (red fleshy berry cup is less toxic, seed is deadly)",
    toxin: "Taxine alkaloids A and B",
    symptoms: ["Sudden death without prior symptoms", "Tremors", "Difficulty breathing", "Cold extremities", "Convulsions"],
    description: "Yew poisoning is notoriously swift. Alpacas can die within 1-2 hours of ingestion due to cardiac arrest caused by taxine alkaloids inhibiting cardiac conduction.",
    treatment: "Often too rapid for treatment. Immediate veterinary stomach emptying and stimulants if caught in minutes.",
    image: "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Pine, Spruce (in moderation), Fir",
    season: "Year-round",
    endpoint: "/api/plants"
  },
  {
    id: "5",
    name: "Oak Leaves & Acorns",
    scientificName: "Quercus spp.",
    category: "Trees & Nuts",
    severity: "Medium",
    toxicityScore: 6.5,
    partsAffected: "Green acorns, oak buds, and young spring leaves",
    toxin: "Tannins and Quercitrin",
    symptoms: ["Constipation followed by black tarry diarrhea", "Kidney failure", "Hollow flank", "Loss of appetite", "Excessive thirst"],
    description: "Listed by Alpaca Guild. Eating large quantities of green acorns or spring oak buds causes tannin poisoning which damages the kidneys and gastrointestinal tract of alpacas.",
    treatment: "Fluid therapy to flush kidneys, mineral oil for GI tract, activated charcoal.",
    image: "https://images.unsplash.com/photo-1513836279014-a89f7a76ae86?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Hazelnut branches, Pecan leaves (clean)",
    season: "Spring & Autumn",
    endpoint: "/api/plants"
  },
  {
    id: "6",
    name: "Bracken Fern",
    scientificName: "Pteridium aquilinum",
    category: "Ferns & Weeds",
    severity: "High",
    toxicityScore: 8.0,
    partsAffected: "Fronds (fresh or in hay) and rhizomes",
    toxin: "Ptaquiloside and Thiaminase (destroys Vitamin B1)",
    symptoms: ["Severe Vitamin B1 (thiamine) deficiency", "Staggering gait", "Muscle twitching", "Weight loss", "Internal bleeding tendencies"],
    description: "Bracken fern destroys thiamine in the alpaca's digestive system or introduces carcinogenic toxins. Dangerous when invading pastures or accidentally baled into grass hay.",
    treatment: "High-dose thiamine (Vitamin B1) injections, supportive electrolyte therapy.",
    image: "https://images.unsplash.com/photo-1516214104703-d870798883c5?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Sword fern, Hay-scented fern (non-toxic species)",
    season: "Summer & Autumn",
    endpoint: "/api/plants"
  },
  {
    id: "7",
    name: "Nightshade & Solanums",
    scientificName: "Solanum spp.",
    category: "Weeds & Garden Plants",
    severity: "High",
    toxicityScore: 8.2,
    partsAffected: "Unripe green berries, leaves, and stems",
    toxin: "Solanine and Glycoalkaloids",
    symptoms: ["Apathy", "Drowsiness", "Bloating & severe colic", "Loss of coordination", "Labored breathing"],
    description: "Featured in the official Alpaca Guild toxic plant directory. Unripe berries and green foliage contain neurotoxic glycoalkaloids.",
    treatment: "Atropine derivatives, saline purges, supportive IV fluids.",
    image: "https://images.unsplash.com/photo-1525310072745-f49212b5ac6d?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Cultivated garden greens (non-nightshades)",
    season: "Summer & Fall",
    endpoint: "/api/plants"
  },
  {
    id: "8",
    name: "Water Hemlock",
    scientificName: "Cicuta maculata",
    category: "Wetland Weeds",
    severity: "Critical",
    toxicityScore: 10,
    partsAffected: "Roots and lower stem (most potent)",
    toxin: "Cicutoxin (violent neurotoxin)",
    symptoms: ["Violent grand mal seizures", "Frothing at the mouth", "Rapid breathing", "Muscle spasms", "Death within 15-30 minutes"],
    description: "Official Alpaca Guild toxic listing. Alpacas grazing near creeks or swampy pastures may unearth the tuberous roots.",
    treatment: "Extremely difficult due to rapid onset. Sedatives to control seizures if vet is instantly available.",
    image: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Cattails, Safe pond reeds",
    season: "Spring to Autumn",
    endpoint: "/api/plants"
  },
  {
    id: "9",
    name: "Avocado",
    scientificName: "Persea americana",
    category: "Foodstuffs & Fruit Trees",
    severity: "High",
    toxicityScore: 7.8,
    partsAffected: "Leaves, bark, skin, and pit",
    toxin: "Persin (fungicidal toxin)",
    symptoms: ["Mastitis-like symptoms in nursing dams", "Cardiovascular congestion", "Respiratory distress", "Fluid accumulation around heart"],
    description: "Listed on Alpaca Guild. Alpacas are exceptionally sensitive to persin found in Guatemalan avocado leaves and pits.",
    treatment: "Anti-inflammatory drugs, diuretics, respiratory support.",
    image: "https://images.unsplash.com/photo-1523049673857-eb18f1d7b578?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Apples (pitted), Bananas, Carrots",
    season: "Year-round",
    endpoint: "/api/plants"
  },
  {
    id: "10",
    name: "Brassica (Cabbage, Broccoli, Kale, Brussels Sprouts)",
    scientificName: "Brassica oleracea spp.",
    category: "Foodstuffs & Vegetables",
    severity: "Medium",
    toxicityScore: 5.5,
    partsAffected: "Large quantities of cruciferous vegetables",
    toxin: "Glucosinolates and S-methylcysteine sulfoxide",
    symptoms: ["Goiter", "Anemia", "Severe digestive upset and gas"],
    description: "Featured in Alpaca Guild official guide. Excessive feeding of cruciferous brassica crops causes metabolic disruption in camelids.",
    treatment: "Dietary correction, supportive care.",
    image: "https://images.unsplash.com/photo-1550989460-0adf9ea622e2?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Timothy hay, Orchard grass, moderate carrots",
    season: "Year-round",
    endpoint: "/api/plants"
  },
  {
    id: "11",
    name: "Castor Bean & Jequirity Bean",
    scientificName: "Ricinus communis",
    category: "Weeds & Garden Plants",
    severity: "Critical",
    toxicityScore: 9.5,
    partsAffected: "Seeds / Beans",
    toxin: "Ricin and Abrin (potent ribosome-inactivating proteins)",
    symptoms: ["Severe abdominal pain", "Bloody diarrhea", "Weakness", "Sweating", "Collapse"],
    description: "Official Alpaca Guild toxic plant directory entry. Extremely potent natural toxins found in ornamental bean seeds.",
    treatment: "Emergency veterinary supportive care, IV fluids, activated charcoal.",
    image: "https://images.unsplash.com/photo-1599592471410-9b48c407fcf8?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Safe forage grains",
    season: "Summer & Fall",
    endpoint: "/api/plants"
  },
  {
    id: "12",
    name: "Foxglove & Monkshood (Aconite)",
    scientificName: "Digitalis purpurea / Aconitum",
    category: "Ornamental Plants",
    severity: "Critical",
    toxicityScore: 9.7,
    partsAffected: "All parts, flowers and leaves",
    toxin: "Digitalis glycosides / Aconitin",
    symptoms: ["Arrhythmias", "Extreme cardiac distress", "Tremors", "Collapse"],
    description: "Included in Alpaca Guild toxic registry. Potent cardiac toxins that disrupt heart rhythms instantly upon ingestion.",
    treatment: "Urgent veterinary cardiac stabilization.",
    image: "https://images.unsplash.com/photo-1533450718592-29d45635f0a9?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Roses, Snapdragons",
    season: "Summer",
    endpoint: "/api/plants"
  },
  {
    id: "13",
    name: "Onions & Garlic (Allium)",
    scientificName: "Allium spp.",
    category: "Foodstuffs & Vegetables",
    severity: "High",
    toxicityScore: 7.5,
    partsAffected: "Bulbs and greens",
    toxin: "N-propyl disulfide",
    symptoms: ["Heinz body hemolytic anemia", "Red/brown urine", "Weakness", "Icterus"],
    description: "Official Alpaca Guild plant hazard. Alliums cause oxidative damage to red blood cells in camelids.",
    treatment: "Supportive care, antioxidant supplements, veterinarian oversight.",
    image: "https://images.unsplash.com/photo-1618512496248-a078b2260a66?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Carrots, apples, orchard grass",
    season: "Year-round",
    endpoint: "/api/plants"
  },
  {
    id: "14",
    name: "Lupin & Locoweed",
    scientificName: "Lupinus / Astragalus spp.",
    category: "Pasture Weeds",
    severity: "High",
    toxicityScore: 8.1,
    partsAffected: "Seeds, pods, and leaves",
    toxin: "Quinolizidine alkaloids / Swainsonine",
    symptoms: ["Birth defects in crias ('crooked calf disease')", "Neurological incoordination", "Depression", "Weight loss"],
    description: "Featured in Alpaca Guild registry. Ingestion by pregnant dams can result in severe skeletal deformities in offspring.",
    treatment: "Removal from pasture, high quality nutrition and vet care.",
    image: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=800",
    safeAlternative: "Clover (in strict moderation), Alfalfa",
    season: "Spring & Summer",
    endpoint: "/api/plants"
  }
];

export const SAFE_ITEMS = [
  { id: "s1", name: "Timothy Grass Hay", category: "Forage", benefit: "Ideal fiber ratio for alpaca forestomach digestion." },
  { id: "s2", name: "Orchard Grass", category: "Forage", benefit: "Highly palatable, clean, and low in dust." },
  { id: "s3", name: "Alfalfa (in moderation/gelts)", category: "Forage", benefit: "High protein and calcium, great for growing cria or lactating dams." },
  { id: "s4", name: "Carrots (Chopped)", category: "Treats", benefit: "Safe vitamin-rich treat when cut into bite-sized pieces to prevent choke." },
  { id: "s5", name: "Apples (Pitted & Sliced)", category: "Treats", benefit: "Delicious occasional snack with seeds and core completely removed." },
  { id: "s6", name: "Willow Branches (Non-toxic species)", category: "Browsing", benefit: "Natural tannins and chewing stimulation." }
];

export const EMERGENCY_STEPS = [
  {
    step: 1,
    title: "Remove from Source Immediately",
    description: "Gently herd alpacas away from the suspect plant or foodstuff. Check mouth for remaining leaves or debris without putting your fingers at risk of bite."
  },
  {
    step: 2,
    title: "Identify the Plant / Save a Sample",
    description: "Take clear photos of leaves, flowers, and stems. Collect a fresh sample in a paper bag for your veterinarian or state agricultural extension office."
  },
  {
    step: 3,
    title: "Assess Vital Signs",
    description: "Check for drooling, labored breathing, bloat (left side swelling), staggering, or unusual gum color (pale or blue). Record temperature if possible (normal: 99.5°F - 102°F)."
  },
  {
    step: 4,
    title: "Call Camelid Veterinarian / Poison Control",
    description: "Contact your local livestock vet immediately. Relay exact weight of alpaca, plant name, and time elapsed since ingestion."
  },
  {
    step: 5,
    title: "Do NOT Induce Vomiting",
    description: "Unlike dogs, camelids cannot vomit easily due to their ruminant-like digestive anatomy. Forcing emesis can cause fatal tracheal aspiration."
  }
];

export const COMMUNITY_REPORTS = [
  {
    id: "r1",
    author: "Dr. Sarah Jenkins, DVM",
    location: "Blue Ridge Alpaca Sanctuary, VA",
    date: "2026-06-12",
    title: "Spring Red Maple Hazard Alert",
    content: "After recent heavy windstorms, several red maple branches fell into Pasture B. Two crias showed early lethargy. Quick removal and veterinary vitamin E/selenium therapy prevented hemolytic crisis. Check fence lines for overhanging trees!",
    severity: "High",
    verified: true
  },
  {
    id: "r2",
    author: "Mark Henderson (Herd Manager)",
    location: "Highland Fleece Farm, OR",
    date: "2026-05-28",
    title: "Rhododendron escape near garden fence",
    content: "Our neighbor's decorative rhododendron bush grew through the wire mesh. Alpacas nibbled the lower foliage resulting in acute drooling and colic. We installed double-fencing 3 feet back.",
    severity: "Critical",
    verified: true
  },
  {
    id: "r3",
    author: "Elena Rostova",
    location: "Pine Valley Alpacas, CO",
    date: "2026-05-14",
    title: "Discarded Lawn Clippings warning",
    content: "A well-meaning visitor dumped lawn mower bags over the paddock fence. Within 2 hours, one female showed severe tympanic bloat. Emergency vet trocar saved her. Never feed clippings!",
    severity: "High",
    verified: true
  }
];

export const VET_CONTACTS = [
  { name: "National Animal Poison Control Center", phone: "(888) 426-4435", hours: "24/7 Emergency Hotline" },
  { name: "Camelid Emergency Vet Network", phone: "(800) 555-ALPACA", hours: "On-call Large Animal Specialists" },
  { name: "ASPCA Animal Poison Control", phone: "(845) 474-7000", hours: "Toxicology Expert Consultations" }
];
